import { ApiResponse, SearchWithRelations, SectionSummary } from 'generated/api'
import { getSearchClient } from 'services/FionaAPI/Search/client'
import { FionaAPIError } from 'services/FionaAPI/templates/errors'
import type { SearchesControllerCreateSearchRequest } from 'generated/api/apis/SearchesControllerApi'

export const createSearch = async (initialData?: SearchesControllerCreateSearchRequest) => {
	return getSearchClient().createSearch({ ...initialData } || {})
}

/**
 * Returns the sectionId that is at the very beginning, no matter if it is completed
 * @param {SearchWithRelations} search
 * @return {any}
 */
export const getInitialSectionId = (search: SearchWithRelations) =>
	search?.sections?.find(section => section.previous === undefined && section.next)

/**
 * Returns the absolute first section of a given search
 * @param {SearchWithRelations} search
 * @return {Promise<ExpandedSection>}
 */
export const getBeginningSectionOfSearch = async (search: SearchWithRelations) => {
	if (search && search?.sections && search.id) {
		const firstSection = getInitialSectionId(search)
		if (firstSection) {
			return await getSearchClient().findSectionWithinSearch({
				searchId: search.id,
				sectionId: firstSection.id!
			})
		}
	}
	throw new FionaAPIError('Search does not have beginning')
}

export const transformExpandedSectionResponse = async (response: ApiResponse<SectionSummary>) => {
	const section = await response.value()
	const progress = parseFloat(response.raw.headers.get('fiona-search-progress') || '0')
	const allowPrefetch = response.raw.headers.get('fiona-search-prefetch') === 'true' ?? false

	if (section) {
		return {
			section,
			progress,
			allowPrefetch
		}
	}

	throw new FionaAPIError('Section does not exist')
}
